export default {
  marketAnalytics: {
    tooltips: {
      title: "Data is updated monthly on the 1st of the month",
    },
    tabs: {
      overview: "Overview",
      marketComparison: "Market Comparison",
      buildingComparison: "Building Comparison",
      visitTimes: "Visit times",
    },
    sorting: {
      highestMedianSold: "Highest median sold",
      lowestMedianSold: "Lowest median sold",
      highestMedianPrice: "Highest median price",
      lowestMedianPrice: "Lowest median price",
      highestAvgImpPerListing: "Highest average impressions per listing",
      lowestAvgImpPerListing: "Lowest average impressions per listing",
    },
    openNewTab: "Open Link in a new tab",
    landing: {
      title: "Research cities that are right for you",
      subtitle:
        "Find out how cities are performing to help you make better decisions in the market.",
      search: {
        placeholder: "Search city, township, project or building names",
        propertyTypePlaceholder: "Property type",
      },
    },
    overview: {
      avgImpressionPerListing: "Average impression per listing per day",
      medianTransactedVolume: "Median transacted volume",
      medianTransactedPrice: "Median transacted price",
      tierWithMostImpression: "Tier with most impressions",
      transactedVolume: "Transacted volume in {location}",
      popularSizeRange: "Popular size range in {location}",
      transactedVolumeSubtitle:
        "How are the average transactions performing in this city",
      transactedVolumeUpdateDescription:
        "Data is updated monthly and backdated 6 months to ensure most transactions are collected to better represent this market.",
      transactedVolumeTooltipText:
        "Data is updated monthly and backdated 6 months to ensure most transactions are collected to better represent this market",
      popularSizeRangeSubtitle:
        "Discover what is the median price and which are the popular size range that are selling well",
      popularSizeRangeTooltipText:
        "Data is updated monthly and backdated 6 months to ensure most transactions are collected to better represent this market",
      more: "more",
      avgImpressionsPerListing: "Average impression per listing per day",
      learnHowAreTheAvgImpressionsPerListingPerformsMonthly:
        "Learn how are the average impression per listing per day performs monthly",
      findOutWhichOfOutProductsGetsTheMostAttentionToStayCompetitiveInThisMarket:
        "Find out which of our products gets the most attention to stay competitive in this market",
      noChange: "no change",
      greyBy: "grew by",
      dropBy: "drop by",
      medianAskingRental: "Median asking rental",
      medianAskingPriceBySizeRange: "Median asking price by size range",
      medianAskingPriceBySizeRangeSubtitle:
        "Discover what is the median price and which are the popular size range that are renting well",
      medianAskingPrice: "Median asking price",
    },
    marketComparison: {
      rankOfMedianTransactedVolume: "Rank of median transacted volume",
      rankOfMedianTransactedPrice: "Rank of median transacted price",
      rankOfMedianAskingRental: "Rank of median asking rental",
      rankOfAvgImpressionPerListing: "Rank of impression per listing per day",
      comparedToAreasIn: "compared to {areas} in",
      sort: "Sort",
      table: {
        columns: {
          rank: "Rank",
          city: "City",
          area: "Area",
          medianSoldPerMonth: "Median sold per month",
          medianPrice: "Median price (RM)",
          avgImpressions: "Average impression per listing per day",
          medianSold: "Median Sold",
          medianAskingRental: "Median asking rental",
        },
      },
      chart: {
        medianTransactedVolumePlotLineText:
          "Median <br /> {medianTransactedVolume}",
        chartFooterDescription:
          "Showing trends of the average transactions from {start} - {end}. <br/>Transactions betwen {uncoveredTransactionStart} - {uncoveredTransactionEnd}  are not represented in this chart, since this data is incomplete for that time period.",
        series: {
          monthlyAvgImpPerListing:
            "Monthly Average impression per listing per day",
          impPerListingPerDay: "Impressions per listing per day",
          monthlyTransactions: "Monthly transactions",
          medianTransactedVolume: "Median transacted volume",
          marketShare: "Market Share(%)",
          medianPrice: "Median Price (RM)",
        },
        tooltip: {
          avgImp: "{avgImpressions} avg impressions",
          medianTransactions: "{median} transactions",
          listingPositions: "Listing positions",
          listings: "Listings",
          avgImpressions: "Avg impressions",
          moreThanStandard: "more than standard",
        },
        legend: {
          highestPeriod: "Highest period",
          medianTransactedPrice: "Median transacted price",
        },
        tiers: {
          premium: "Premium",
          feature: "Featured",
          standard: "Standard",
          noListing: "No Listing",
        },
        tiersByListingPosition: {
          topOfPage1: "Top of page 1",
          listingPositions: "Listing positions",
          bottomOfPage1: "Bottom of page 1",
        },
        noData: {
          title: "Insufficient data.",
          content: "It seems there’s not enough data available.",
        },
      },
    },
    buildingComparison: {
      table: {
        columns: {
          rank: "Rank",
          building: "Building",
          buildingType: "Building type",
          medianSold: "Median sold per month",
          medianPrice: "Median price (RM)",
          avgImpressions: "Average impression per listing per day",
        },
      },
      rankOfMedianTransactedVolume: "Rank of median transacted volume",
      rankOfMedianTransactedPrice: "Rank of median transacted price",
      rankOfMedianAskingRental: "Highest median asking rental",
      rankOfAvgImpressionPerListing: "Rank of impression per listing per day",
      highestMedianSold: "Highest median sold",
      highestMedianPrice: "Highest median price",
      highestAvgImpressionPerListing:
        "Highest average impression per listing per day",
      popularBuildingsIn: "Popular Buildings in",
      sort: "Sort",
      openNewTab: "Open Link in a new tab",
    },
    visitTimes: {
      busiestDay: "Busiest day",
      lowestDay: "Lowest day activity",
      busiestTime: "Busiest time",
      lowestTime: "Lowest time activity",
    },
    maintenance: {
      title: "Market Analytics platform is undergoing an upgrade!",
      description:
        "We're currently performing maintenance to enhance data accuracy and quality. <br />" +
        "Stay tuned for updates on when the improved features will be available.",
    },
  },
};
